import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function PasswordChangeAlert() {
  const { passwordRequirement, role } = useAuth();
  const navigate = useNavigate();
  const [timeRemaining, setTimeRemaining] = useState<string>('');
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!passwordRequirement || role !== 'patient') {
      setShow(false);
      return;
    }

    if (passwordRequirement.mustChangePassword && !passwordRequirement.deadlinePassed) {
      setShow(true);

      // Calculer le temps restant
      const updateTimeRemaining = () => {
        if (!passwordRequirement.deadline) return;

        const deadline = new Date(passwordRequirement.deadline);
        const now = new Date();
        const diff = deadline.getTime() - now.getTime();

        if (diff <= 0) {
          setTimeRemaining('Expiré');
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        setTimeRemaining(`${hours}h ${minutes}min`);
      };

      updateTimeRemaining();
      const interval = setInterval(updateTimeRemaining, 60000); // Mettre à jour chaque minute

      return () => clearInterval(interval);
    } else {
      setShow(false);
    }
  }, [passwordRequirement, role]);

  if (!show) return null;

  return (
    <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-40 w-full max-w-2xl px-4 animate-bounce">
      <div className="bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-2xl shadow-2xl p-4 border-2 border-white">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 animate-pulse">
            <i className="ri-alarm-warning-line text-2xl"></i>
          </div>
          
          <div className="flex-1">
            <h3 className="font-bold text-lg mb-1">
              <i className="ri-lock-password-line mr-2"></i>
              Changement de mot de passe requis
            </h3>
            <p className="text-sm text-white/90 mb-3">
              Votre compte a été créé par un membre du personnel médical. Pour des raisons de sécurité, vous devez changer votre mot de passe.
            </p>
            
            <div className="flex items-center gap-4 flex-wrap">
              <div className="bg-white/20 px-4 py-2 rounded-full text-sm font-semibold">
                <i className="ri-time-line mr-2"></i>
                Temps restant : {timeRemaining}
              </div>
              
              <button
                onClick={() => navigate('/change-password')}
                className="px-6 py-2 bg-white text-red-600 rounded-full font-semibold hover:bg-red-50 transition-all shadow-lg hover:shadow-xl transform hover:scale-105 whitespace-nowrap"
              >
                Changer maintenant
              </button>
            </div>
          </div>
          
          <button
            onClick={() => setShow(false)}
            className="w-8 h-8 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-all flex-shrink-0"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
